import React from 'react';
import { useActivation } from '@context/MobileOne';
import { useA11y } from '@context/Utils';
import {
  ButtonPrimary,
  ScrollToTop,
  Ta11yText,
  Ta11yImage,
  Chip,
  Meta
} from '@core/index';
import { appTariffs, appButtonType, appChipStyle, appIconsPath } from '@utils/globalConstant';
import { AppPageContentWrapper } from '@part/AppPageContentWrapper';
import useCmsImage from '@utils/useCmsImage';

export function MpsAutoTopupDetails() {
  const { setStep8SubStep, setWithAutoTopup, tariffActivationForm } = useActivation();
  const { tA11yTranslate, getGlobalMetaTitles } = useA11y();

  const backgroundImage = useCmsImage('ek_autotopup_dtls_bg');
  
  const { globalPageTitle } = getGlobalMetaTitles();
  const autoTopUpDetailsPageTitle = tA11yTranslate('ek_global_autotopup_dtls_page_title').content;
  const pageTitle = `${globalPageTitle} - ${autoTopUpDetailsPageTitle}`;

  const detailsConfig = {
    pageTitle,
    backgroundImage,
    heading: tA11yTranslate('ek_global_autotopup_dtls_hdl1'),
    text1: tA11yTranslate('ek_global_autotopup_dtls_txt1'),
    text2: tA11yTranslate('ek_global_autotopup_dtls_txt2'),
    buttonText: tA11yTranslate('ek_global_autotopup_dtls_btn1')
  };

  const handleConfirm = () => {
    setWithAutoTopup(true);
    if (
      tariffActivationForm.chosenTariffId === appTariffs.TALK ||
      tariffActivationForm.chosenTariffId === 0
    ) {
      // go to activation amount page for START tariff
      setStep8SubStep(2);
    } else {
      // go directly to activation payment method page for all other tariffs
      setStep8SubStep(3);
    }
  };

  return (
    <ScrollToTop>
      {detailsConfig.backgroundImage && (
        <div className="w-100 mb-24" style={{ height: '240px', overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Ta11yImage 
            imageContent={detailsConfig.backgroundImage} 
            style={{ objectFit: 'cover', height: '100%', width: '100%' }} 
          />
        </div>
      )}
      
      <AppPageContentWrapper>
        <Meta title={detailsConfig.pageTitle} />

        <div className="mb-32">
          <Chip
            chipStyle={appChipStyle.HIGHLIGHT}
            icon={appIconsPath.REWARD}
            label="ek_global_recommended_chip"
          />
        </div>

        <Ta11yText
          textContent={detailsConfig.heading}
          tag="h1"
          className="ek-copy-20-semibold text-primary mb-24"
        />

        <Ta11yText
          textContent={detailsConfig.text1}
          tag="p"
          className="mb-24 ek-copy-16-regular text-primary"
        />

        <Ta11yText
          textContent={detailsConfig.text2}
          tag="p"
          className="mb-24 ek-copy-16-regular text-primary"
        />

        <div className="w-100">
          <ButtonPrimary
            buttonType={appButtonType.PRIMARY}
            buttonContent={detailsConfig.buttonText}
            onClick={handleConfirm}
          />
        </div>
      </AppPageContentWrapper>
    </ScrollToTop>
  );
}

export default MpsAutoTopupDetails;